
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="isScreenAccessible else screenNotAccessible">
  <div class="flex flex-column card-container">
    <p-tabView [activeIndex]="activeIndex">
      <p-tabPanel header="My Delegations">
        <div class="flex flex-column">
          <div class="flex justify-content-end m-1">
        <p-button
        appPreventDoubleClick
          label="{{addDelegationTitle}}"
          id="addDelegateButton"
          class="add-delegate-button"
          icon="fa fa-plus"
          iconPos="left"
          (debounceClick)="addDelegation()"
        ></p-button>
        </div>
        <div class="flex m-1">
          <div class="w-full">
          <app-my-delegations></app-my-delegations>
          </div>
        </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Delegated To Me">
        <app-delegated-to-me></app-delegated-to-me>
      </p-tabPanel>
      <app-delegation-slider 
      [isDelegateSliderOpen]="isDelegateSliderOpen" 
      (isDelegateSliderActive)="closeDelegateSlider($event)"
      ></app-delegation-slider>
    </p-tabView>
  </div>
</div>
<ng-template #screenNotAccessible>
  <app-error [errorMessage]="errorMessage"></app-error>
</ng-template>
